/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { getAPI } from "../../utils/common";
import { ALL_CARRER_APPLIEDS, RESUME_BASE_URL } from "../../constants/api";
import { Space, Button, Table } from "antd";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Layout } from "antd";
import { Card } from "antd";
import { displayMessage } from "../../utils/common";
import { ERROR_MSG_TYPE } from "../../constants/messages";

function CarrerAppliedTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setstate] = useState([]);
  const [loading, setloading] = useState(true);

  useLayoutEffect(() => {
    if (state.length === 0) {
      getUser();
    }
  }, [state, navigate]);
  const getUser = () => {
    const successFn = function (data) {
      console.log(data);
      setloading(false);
      setstate(
        data["data"].map((row) => ({
          fullName: row.fullName,
          previousJobTitle: row.previousJobTitle,
          email: row.email,
          phone: row.phone,
          resume: (
            <Space>
              <Button
                onClick={() => {
                  window.open(RESUME_BASE_URL + row.resume, "_blank")
                }}
                block
              >
                Resume
              </Button>
              <Button
                onClick={() => {
                  window.open(row.linkedin_link, "_blank")
                }}
                block
              >
                Linkedin
              </Button>
            </Space>
          ),
          applied_for: row.applied_for,
          date: row.created_at,
        }))
      );
      console.log(state);
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    getAPI(ALL_CARRER_APPLIEDS, successFn, errorFn, {});
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullName",
      width: 150,
    },
    {
      title: "Previous Job Title",
      dataIndex: "previousJobTitle",
      width: 50,
    },

    {
      title: "Email",
      dataIndex: "email",
      width: 150,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      width: 150,
    },
    {
      title: "Applied For",
      dataIndex: "applied_for",
      width: 150,
    },

    {
      title: "Date",
      dataIndex: "date",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "resume",
      width: 150,
    },
  ];
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card title="Carrer Applieds" bordered={true}>
            <Table
              loading={loading ? true : false}
              columns={columns}
              dataSource={state}
              pagination={{ pageSize: 10 }}
              // scroll={{ y: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default CarrerAppliedTable;
